import { render, staticRenderFns } from "./LarabergEditor.vue?vue&type=template&id=3c5080cc&"
import script from "./LarabergEditor.vue?vue&type=script&lang=js&"
export * from "./LarabergEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\Users\\Amirreza\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service-global\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports